import { render, staticRenderFns } from "./NewsStandRipe.vue?vue&type=template&id=553920a3&"
import script from "./NewsStandRipe.vue?vue&type=script&lang=js&"
export * from "./NewsStandRipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LRGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('553920a3')) {
      api.createRecord('553920a3', component.options)
    } else {
      api.reload('553920a3', component.options)
    }
    module.hot.accept("./NewsStandRipe.vue?vue&type=template&id=553920a3&", function () {
      api.rerender('553920a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/news-stand-ripe/NewsStandRipe.vue"
export default component.exports